export function getTableItemsWithTotalRows<T extends Record<string, any> = any>(
	items: Array<T>
): { dataItems: (T | null)[], tableClassName: string } {
	const refLength = 10
	const dataItems = items.length > 0 ?
		(items.length > refLength ? [null, ...items, null] : [...items, null]) : items
	const tableClassName = `${items.length > refLength ? 'border-total-top' : ''} ${items.length > 0 ? 'border-total-bottom' : ''}`

	return {
		dataItems,
		tableClassName
	}
}